import React from 'react';

import { GADataType } from '../../../../../../../types';
import { IconsEnum } from '../../../../../../../assets/icons/types';

import { PureTooltipIconButtonHelper } from '../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { Files } from '../../../../../../../utils/Files';

import { ProductsListItemOpenLightboxButtonProduct } from './ProductsListItemOpenLightboxButton.types';

interface ProductsListItemOpenLightboxButtonProps {
  product: ProductsListItemOpenLightboxButtonProduct;
  onLightboxOpen: () => void;
}

function ProductsListItemOpenLightboxButton({
  dataGa,
  product,
  onLightboxOpen
}: ProductsListItemOpenLightboxButtonProps & GADataType) {
  const hasImage = product.image?.file && Files.isImage(product.image.file);

  if (!hasImage) {
    return null;
  }

  return (
    <PureTooltipIconButtonHelper
      dataGa={dataGa}
      className="bg-white dark:bg-gray-900 dark:hover:bg-gray-700 dark:text-gray-300 focus:ring-offset-0 font-medium hover:bg-gray-200 inline-flex items-center p-1 rounded-md text-gray-700 text-sm pointer-events-auto shadow dark:glow"
      icon={IconsEnum.ARROWS_EXPAND_SOLID}
      iconClassName="h-5 w-5"
      tooltipI18nText="words.expand_view"
      tooltipSingleton
      onClick={onLightboxOpen}
    />
  );
}

export default ProductsListItemOpenLightboxButton;
